import React from 'react';

const Footer1 = () => {
    return (
        <footer className="bg-gray-900 text-custom-white py-10 px-5 text-sm mt-32">
            <div className="max-w-6xl mx-auto -mt-24 mb-0 flex flex-wrap justify-evenly bg-custom-white text-gray-700 p-5 border border-gray-200 rounded-3xl shadow-[0_0_20px_1px_#00000024]">
                {/* About Us Section */}
                <div className="w-full sm:w-1/4 mb-6 sm:mb-0">
                    <h4 className="text-gray-500 uppercase mb-3">About Prapancha Pravasa</h4>
                    <ul>
                        <li className="mb-2"><a href="/about-us" className="text-custom-blue hover:underline">About Us</a></li>
                        <li className="mb-2"><a href="/terms-and-conditions" className="text-custom-blue hover:underline">Terms & Conditions</a></li>
                        <li className="mb-2"><a href="/privacy-policy" className="text-custom-blue hover:underline">Privacy Policies</a></li>
                        {/* <li className="mb-2"><a href="#" className="text-custom-blue hover:underline">Copyright Policies</a></li>
                        <li className="mb-2"><a href="#" className="text-custom-blue hover:underline">Support</a></li>
                        <li className="mb-2"><a href="#" className="text-custom-yellow hover:underline">Beware of Frauds <span className="inline-block">⚠</span></a></li> */}
                    </ul>
                </div>

                {/* Contacts Information Section */}
                <div className="w-full sm:w-1/4 mb-6 sm:mb-0">
                    <h4 className="text-gray-500 uppercase mb-3">Contacts Information</h4>
                    <ul>
                        <li className="mb-2 text-custom-blue">
                            <strong>Address:</strong> 1st Floor, 603, 1st Main Road, 2nd Cross Rd, near Jain Temple, T. Dasarahalli, Bengaluru, Karnataka 560057
                        </li>
                        <li className="mb-2 text-custom-blue">
                            <strong>Email:</strong> <a href="mailto:book@prapanchapravasa.com" className="text-custom-blue hover:underline">book@prapanchapravasa.com</a>
                        </li>
                        <li className="mb-2 text-custom-blue">
                            <strong>Contacts:</strong> 63602 04100, 78997 30480,<br /> 72042 47400, 82964 63588
                        </li>
                    </ul>
                </div>

                {/* Travel Destinations Section with Image Grid */}
                <div className="w-full sm:w-1/4 mb-6 sm:mb-0">
                    <h4 className="text-gray-500 uppercase mb-3">Travel Destinations</h4>
                    <div className="grid grid-cols-3 gap-2">
                        <div>
                            <a href="#">
                                <img src="https://images.unsplash.com/photo-1543579596-2c11997c7706?q=80&w=2126&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Dubai" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Dubai</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://plus.unsplash.com/premium_photo-1697729432930-3f11644e9184?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Singapore" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Singapore</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://plus.unsplash.com/premium_photo-1661963573455-ba0446e2cab9?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="India" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">India</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Thailand" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Thailand</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://images.unsplash.com/photo-1545762374-d18079617da8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Andaman" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Andaman</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://images.unsplash.com/photo-1623595289196-007a22dd8560?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Sri Lanka" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Sri Lanka</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://images.unsplash.com/photo-1600438831035-48f5f196d3bf?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Ladakh" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Ladakh</p>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <img src="https://images.unsplash.com/photo-1736874259597-8fb99413416e?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Hongkong" className="w-full h-16 object-cover rounded-md" />
                                <p className="text-center mt-1 text-custom-blue hover:underline">Hongkong</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Social Media and Copyright */}
            <div className="max-w-6xl mx-auto mt-5 text-center">
                <div className="flex justify-center space-x-4 mb-4">
                    <a href="https://www.facebook.com/share/16EoVtiPsC/?mibextid=wwXIfr" className="text-custom-white hover:text-custom-yellow">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" className="w-6 h-6" />
                    </a>
                    <a href="https://www.instagram.com/prapanchapravasa?igsh=MWloZGN1c2Fzd25kMA==" className="text-custom-white hover:text-custom-yellow">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" className="w-6 h-6" />
                    </a>
                    {/* <a href="#" className="text-custom-white hover:text-custom-yellow">
                        <img src="https://img.icons8.com/?size=100&id=108794&format=png&color=000000" alt="YouTube" className="w-6 h-6" />
                    </a> */}
                </div>
                <p className="text-gray-300 text-xs">
                    © 2025-26 Prapancha Pravasa Tours Private Limited. All rights reserved.
                </p>
                <p className="text-gray-300 text-xs mt-2">
                    The content and images used on this site are copyright protected and copyrights vest with the respective owners. The usage of the content and images on this website is intended to promote the works and no endorsement of the artist shall be implied. Unauthorized use is prohibited and punishable by law.
                </p>
            </div>
        </footer>
    );
};

export default Footer1;